// These must be the first lines in src/index.js
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

window.addEventListener('load', (e)=>{

  ReactDOM.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
    document.getElementById('resautcat-content-container')
  );

  if(process.env.NODE_ENV === 'development'){
    var resautcat_page_admin = document.querySelector('#resautcat-page-admin');
    resautcat_page_admin.style.opacity = 1;
  }
});